import { trackersCapture, trackersIdentify } from '@/lib/trackers'

/*
 * Each event under the names Google and Meta expect, and the plain name PostHog
 * shows it under. Signing up and requesting a booking have no PostHog name: the
 * server tells PostHog those for every account, consent or not, so the browser
 * would only count them twice.
 */
const eventMapping = {
  addPaymentInfo: { ga4: 'add_payment_info', fbq: 'AddPaymentInfo', posthog: 'payment_details_entered' },
  applyFilter: { ga4: 'apply_filter', fbq: 'FilterApplied', posthog: 'filter_applied' },
  completeRegistration: { ga4: 'sign_up', fbq: 'CompleteRegistration', posthog: null },
  contact: { ga4: 'contact', fbq: 'Contact', posthog: 'tutor_enquiry_opened' },
  initiateCheckout: { ga4: 'begin_checkout', fbq: 'InitiateCheckout', posthog: 'checkout_started' },
  login: { ga4: 'login', fbq: 'Login', posthog: 'logged_in' },
  purchase: { ga4: 'purchase', fbq: 'Purchase', posthog: null },
  search: { ga4: 'search', fbq: 'Search', posthog: 'searched' },
  submitApplication: { ga4: 'submit_application', fbq: 'SubmitApplication', posthog: 'tutor_application_submitted' },
  tutorRegistrationBegin: { ga4: 'sign_up_tutor_begin', fbq: 'TutorRegistrationBegin', posthog: 'tutor_application_started' },
  tutorRegistrationEnd: { ga4: 'sign_up_tutor_end', fbq: 'TutorRegistrationEnd', posthog: 'tutor_application_services_saved' },
  viewContent: { ga4: 'view_item', fbq: 'ViewContent', posthog: 'content_viewed' },
  viewTutor: { ga4: 'view_item', fbq: 'ViewContent', posthog: 'tutor_viewed' },
}

let identifiedUserId = null

export function identifyVisitor(user) {
  const userId = user?.id ? String(user.id) : null

  trackersIdentify(user)

  if (!userId || userId === identifiedUserId) {
    return
  }

  identifiedUserId = userId

  window.LOQ = window.LOQ || []
  window.LOQ.push(['ready', async (LO) => {
    await LO.$internal.ready('visitor')
    LO.visitor.identify(userId, {
      email: user.email,
      name: user.name,
      user_type: user.user_type,
    })
  }])
}

export function trackEvent(event, params = {}) {
  const mappedEvent = eventMapping[event]

  if (!mappedEvent) {
    console.warn(
      `[Analytics] Event '${event}' is not mapped to GA4 or Facebook Pixel.`
    )
    return
  }

  // console.log(`[Analytics] trackEvent: ${event}`, {
  //     ga4: mappedEvent.ga4,
  //     fbq: mappedEvent.fbq,
  //     params,
  //     gtag_available: typeof window.gtag === 'function',
  //     fbq_available: typeof window.fbq === 'function',
  // });

  if (mappedEvent.posthog) {
    trackersCapture(mappedEvent.posthog, params)
  }

  if (typeof window.gtag === 'function') {
    window.gtag('event', mappedEvent.ga4, params)
  }

  // Push to Google Tag Manager dataLayer
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: mappedEvent.ga4,
      ...params,
    })
  }

  if (typeof window.fbq === 'function') {
    window.fbq('track', mappedEvent.fbq, params)
  }
}
